module.exports = {"id":"226637","name":"Rubén Duarte","rating":"72","photo":"./data/images/photos/3/226637.png","club":{"name":"Deport. Alavés","logo":"./data/images/clubs/Deport.Alaves.png"},"positions":["DG"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/RubenDuarte0.json
// module id = 3731
// module chunks = 0